import React, { useEffect, useState } from "react";
import "../css/SignCss.css";
import logo from "../images/logo-miraclesehr.png";
import googleIcon from "../images/google-icon.png";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-tippy/dist/tippy.css";
import { Button, CircularProgress } from "@mui/material";
import { showCustomToast } from "./Misc/CustomToast";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { getFunctions, httpsCallable } from "firebase/functions";

export default function Login() {
  const navigate = useNavigate();
  const { signInWithGoogle, logOut } = useAuth();
  const { currentUser } = useAuth();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  useEffect(() => {
    async function fetchUserRoleAndNavigate() {
      // Si currentUser n'est pas null, alors l'utilisateur est connecté
      if (currentUser) {
        // Récupérez le document de rôle pour l'utilisateur actuel
        const docRef = doc(db, "roles", currentUser.uid);
        const docSnap = await getDoc(docRef);

        // Vérifiez si le document existe et si le rôle est "Normal User"
        if (docSnap.exists()) {
          if (docSnap.data().role === "Normal User" || !docSnap.data().role) {
            navigate("/account");
          } else {
            navigate("/");
          }
        } else {
          // S'il n'y a pas de rôle défini, redirigez vers "/account"
          navigate("/account");
          console.log("Aucun rôle trouvé pour cet utilisateur dans Firestore");
        }
      }
    }

    fetchUserRoleAndNavigate();
  }, [currentUser, navigate]);

  function handleSignInWithGoogle() {
    setIsLoggingIn(true);
    signInWithGoogle()
      .then(async (result) => {
        try {
          const functions = getFunctions();
          const setExternalClaims = httpsCallable(
            functions,
            "setExternalClaims"
          );
          await setExternalClaims();
          await result.user.getIdToken(true);
        } catch (error) {
          console.error("Failed to refresh claims:", error);
        }

        const email = (result.user.email || "").toLowerCase();
        const isInternal = email.endsWith("@miraclesasia.com");
        let isExternalAllowed = false;

        try {
          const tokenResult = await result.user.getIdTokenResult(true);
          isExternalAllowed = tokenResult?.claims?.external === true;
        } catch (error) {
          console.error("Failed to read claims:", error);
        }
        // Vérifiez le domaine de l'email ici et affichez un message d'erreur si nécessaire
        if (!isInternal && !isExternalAllowed) {
          showCustomToast(
            `You must log in with an @miraclesasia.com email or a whitelisted external email.`,
            "error"
          );
          await logOut();
          setIsLoggingIn(false);
          return;
        }

        showCustomToast(
          `Successfully logged in using your Google account`,
          "success"
        );
      })
      .catch((error) => {
        setIsLoggingIn(false);
        if (error.code === "permission-denied") {
          showCustomToast(
            `You must log in with an @miraclesasia.com email or a whitelisted external email.`,
            "error"
          );
        } else {
          showCustomToast(`Failed to log in with your Google account`, "error");
        }
      });
  }

  return (
    <div className="sign-main-container">
      {isLoggingIn && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.35)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress size={80} thickness={4} />
        </div>
      )}
      {window.innerWidth < 400 ? (
        <div />
      ) : (
        <div className="logo">
          <img src={logo} alt="" />
        </div>
      )}
      {/* <div className="logo">
        <img src={logo} alt="" />
      </div> */}
      <div className="sign-left-container">
        <div className="alert-container-top"></div>
        <div className="signup-container-title">
          <div className="signup-title">Welcome to Bodhi</div>
          <div className="signup-subtitle">Continue with Google</div>
        </div>

        <div className="container-google-sso">
          <Button
            sx={{
              borderRadius: "20px",
              width: "45%",
              height: "auto",
              "@media (max-width: 1100px)": {
                width: "90%",
              },
            }}
            variant="outlined"
            onClick={handleSignInWithGoogle}
          >
            {" "}
            <img alt="Google icon" src={googleIcon} className="google-icon" />
            Log in with Google account
          </Button>
        </div>
      </div>

      <div className="sign-right-container"></div>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  );
}



